var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"toTop",on:{"click":_vm.toTop}},[_c('svg',{staticClass:"q-icon notranslate",staticStyle:{"width":"16px","height":"16px"},attrs:{"aria-hidden":"true","role":"presentation","focusable":"false","viewBox":"0 0 24 24"}},[_c('use',{attrs:{"xlink:href":"#icon-backtotop"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }